import { Chart, ChartOption } from '@/components/Base/Chart.tsx';
import { formatLargeNumber } from '@/utils/formatLargNumber';
import { Box } from '@mui/material';
import { groupBy } from 'lodash';

const ScoreFaturamentoChart = ({ color, title, labelColor, data }) => {
  console.log('data', data)

  const months = data?.map((item) => item.ano);
  const values = data?.map((item) => item.valor);

  console.log({months,values })


  const series = [
    {
      data: values,
      type: 'bar',
      stack: 'a',
      name: 'Faturamento',
      barMaxWidth: 60,
      itemStyle: {
        borderRadius: [15, 15, 15, 15],
        color: color,
      },
      label: {
        show: true,
        formatter: (params) => formatLargeNumber(Number(params.value.toFixed(2))),
        position: 'top',
        backgroundColor: labelColor,
        padding: [5, 10],
        borderRadius: [5],
        fontSize: '12px',
        fontWeight: 600,
      },
    },
  ];

  const option = {
    title: {
      text: title,
      padding: [
        16,
        5,
        5,
        23,
      ],
      textStyle: {
        fontSize: '14px'
      }
    },
    legend: {
      data: ['Pago', 'Faturamento'],
      right: '0',
      padding: [
        16,
        23,
        5,
        5,
      ],
      icon: 'circle'
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    },
    yAxis: [{
      type: 'value',
    }, {
      axisLabel: {
        formatter: '',
      },
    }],
    xAxis: {
      type: 'category',
      data: months,
    },
    tooltip: {
      trigger: 'axis',
      formatter: (params) => {
        const month = params[0].name; 
        const value = formatLargeNumber(Number(params[0].value.toFixed(2))); 
        return `${month}: ${value}`;
      },
    },
    series,
  } as ChartOption;

  return (
    <Box sx={{ boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)' }} height={'400px'}>
      <Chart option={option} />
    </Box>
  );
};

export default ScoreFaturamentoChart;